<template>
  <div class="form-group-s" style="position: relative;">
    <label v-if="getTitle">
      {{model.$schema.title}}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>

    <label class="textarea" :class="{'state-error': model.$error, 'state-disabled': disabled}">
      <i
        class="icon-prepend fa"
        v-if="prependicon"
        :class="prependicon.startsWith('fa-') ? prependicon : ''"
      >{{prependicon.startsWith('fa-') ? '' : prependicon}}</i>
      <textarea
        ref="input"
        style="overflow: hidden"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        @input="onInput($event)"
        @blur="onTextareaBlur($event)"
        :class="classObject"
        :placeholder="placeholder"
        @focus="onTextareaFocus($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
        :name="model.$form.testPath ? model.$path : undefined"
      ></textarea>
      <textarea
        v-if="useHelper"
        ref="hresize"
        class="form-control areahelper"
        style="overflow: hidden"
        tabindex="-1"
      ></textarea>
      <i
        class="icon-append fa"
        v-if="appendicon"
        :class="appendicon.startsWith('fa-') ? appendicon : ''"
      >{{appendicon.startsWith('fa-') ? '' : appendicon}}</i>
    </label>

    <div v-if="model.$schema.maxLength!==undefined" class="text-note text-muted">
      <small
        :class="{'text-danger': (length>model.$schema.maxLength)}"
      >{{length}} z {{model.$schema.maxLength || 0}}</small>
    </div>

    <w-error :model="model" @focus="$refs.input.focus()"></w-error>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: tooltipVisibility}"

import modelMixin from '../mixins/modelMixin';

import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    }
  },
  mixins: [modelMixin],
  components: {WError, WTooltip},
  data() {
    return {
      length: 0,
      useHelper: false
    };
  },
  mounted() {
    // czy ma sie robic resize przy zmianiae modelu ?
    // console.log('textarea mounted', this.$refs);
    if (true) {
      // console.log('monted $refs', Object.keys(this.$refs));
      this.$watch('svalue', {
        immediate: true,
        handler(newValue) {
          // console.log('$watch textarea', this.$refs);
          this.resize(newValue);
        }
      });
    } else {
      // czy ma się robić resize od razu po podłączeniu
      if (true) {
        this.resize();
      } else if (this.svalue) {
        this.length = this.svalue.length;
      } else {
        this.length = 0;
      }
    }
    // this.resize();
  },
  computed: {
    classObject() {
      const result = ['form-control'];
      if (this.borderless) {
        result.push('borderless');
        if (this.useHelper) {
          result.push('active');
        }
      }

      return result;
    }
  },
  methods: {
    resize(newValue, blur) {
      // console.log('newValue: ', newValue);
      // console.log('$refs', Object.keys(this.$refs));

      if (newValue === undefined) {
        if (this.svalue === undefined) {
          newValue = '';
        } else {
          newValue = this.svalue;
        }
      }

      // let prevheight = this.$options.prevHeight || this.$refs.input.offsetHeight;
      this.length = (newValue || '').length || 0;

      let newHeight = 0;
      if (this.useHelper) {
        if (this.$refs.hresize === undefined) {
          return;
        }
        if (blur) {
          // trzeba zrobić jako opcję
          /*
                this.$refs.input.style.height = "auto";
                this.$refs.input.style.overflow = "auto";
                */
          return;
        }
        this.$refs.hresize.value = newValue + 'aaa';
        // console.log('hresize.value: ', newValue, this.$refs.hresize.value);
        const height = this.$refs.hresize.scrollHeight;
        newHeight = height + 2;
        // console.log('helper textHeight', newHeight);
      } else {
        if (this.$refs.input === undefined) {
          return;
        }
        newHeight = this.$refs.input.scrollHeight + 2;
        // console.log('my textHeight', newHeight);
      }
      // if (newHeight!=height) {
      // console.log('height: ',prevheight,height);
      // console.log('height: ', height);
      //  this.$options.prevHeight=newHeight;
      this.$refs.input.style.overflow = 'hidden';
      this.$refs.input.style.height = newHeight + 'px';
      // }
    },
    onTextareaFocus(evt) {
      // this.model.$hasFocus = true;
      // console.log('localfocus', this.model.$hasFocus);
      this.useHelper = true;
      this.onFocus(evt);
      // eturn true;
      // this.$emit('focus', evt);
    },
    onTextareaBlur(evt) {
      this.useHelper = false;
      // this.resize();
      this.onBlur(evt);
    }
  }
};
</script>

<style>
textarea.areahelper {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
textarea.active {
  background-color: lightyellow !important;
}
</style>

